import React, { useEffect, useRef, useState } from "react";
import { Send, X, Sparkles, Bot } from "lucide-react";
import { api } from "../lib/api";

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", content: "¡Hola! 👋 Soy ALA, tu asistente. Puedo ayudarte con figuras 3D, papelería personalizada, precios, tiempos y más. ¿En qué te ayudo hoy?" },
  ]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  const send = async (e) => {
    e?.preventDefault();
    const text = input.trim();
    if (!text || sending) return;
    setInput("");
    const newMsgs = [...messages, { role: "user", content: text }];
    setMessages(newMsgs);
    setSending(true);
    try {
      const res = await api.post("/chat", { message: text, session_id: sessionId });
      setSessionId(res.data.session_id);
      setMessages([...newMsgs, { role: "assistant", content: res.data.reply }]);
    } catch (err) {
      setMessages([...newMsgs, { role: "assistant", content: "Lo siento, tuve un problema. Intenta de nuevo o escríbenos por WhatsApp 📱" }]);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          data-testid="chat-open-btn"
          className="fixed bottom-24 right-6 z-40 group"
          aria-label="Abrir chat"
        >
          <span className="absolute inset-0 rounded-full bg-yolk animate-ping opacity-30" />
          <span className="relative flex items-center gap-2 bg-yolk text-black pl-2 pr-4 py-2 rounded-full shadow-lg hover:scale-105 transition border-2 border-black">
            <span className="h-9 w-9 rounded-full bg-black text-yolk flex items-center justify-center">
              <Bot className="h-5 w-5" />
            </span>
            <span className="font-heading font-bold text-sm">¿Te ayudo?</span>
          </span>
        </button>
      )}

      {open && (
        <div data-testid="chat-window" className="fixed bottom-24 right-4 sm:right-6 z-40 w-[calc(100vw-2rem)] sm:w-96 bg-white border-2 border-black shadow-2xl flex flex-col" style={{ maxHeight: "70vh", height: 540 }}>
          <div className="flex items-center justify-between p-4 bg-mint-deep text-white border-b-2 border-black">
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-full bg-yolk text-black flex items-center justify-center border-2 border-black">
                <Sparkles className="h-4 w-4" />
              </div>
              <div>
                <h3 className="font-heading font-bold leading-tight">ALA · Asistente</h3>
                <p className="text-[11px] opacity-80">En línea · responde rápido</p>
              </div>
            </div>
            <button onClick={() => setOpen(false)} data-testid="chat-close-btn" className="h-8 w-8 hover:bg-white/15 rounded-full flex items-center justify-center">
              <X className="h-4 w-4" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-cream">
            {messages.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap ${m.role === "user" ? "bg-mint-deep text-white" : "bg-white border-2 border-black text-brand-ink"}`}>
                  {m.content}
                </div>
              </div>
            ))}
            {sending && (
              <div className="flex justify-start">
                <div className="bg-white border-2 border-black px-4 py-2.5 text-sm">
                  <span className="inline-flex gap-1">
                    <span className="h-1.5 w-1.5 rounded-full bg-mint-deep animate-bounce" style={{animationDelay:"0ms"}}></span>
                    <span className="h-1.5 w-1.5 rounded-full bg-mint-deep animate-bounce" style={{animationDelay:"150ms"}}></span>
                    <span className="h-1.5 w-1.5 rounded-full bg-mint-deep animate-bounce" style={{animationDelay:"300ms"}}></span>
                  </span>
                </div>
              </div>
            )}
            <div ref={endRef} />
          </div>

          <form onSubmit={send} className="p-3 border-t-2 border-black bg-white flex items-center gap-2">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Escribe tu mensaje..."
              data-testid="chat-input"
              className="flex-1 border-2 border-black px-3 py-2.5 text-sm focus:outline-none focus:border-mint-deep"
              disabled={sending}
            />
            <button type="submit" disabled={sending || !input.trim()} data-testid="chat-send-btn" className="h-11 w-11 bg-mint-deep border-2 border-black text-white flex items-center justify-center disabled:opacity-50 hover:bg-mint">
              <Send className="h-4 w-4" />
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
